<mat-nav-list class="nav-list">
  <mat-expansion-panel *ngFor="let panel of panels" [expanded]="panel.expanded">
    <mat-expansion-panel-header>
      <mat-icon class="panel-icon">{{ panel.icon }}</mat-icon>
      <span class="panel-title">{{ panel.title }}</span>
    </mat-expansion-panel-header>
    <mat-nav-list>
      <a *ngFor="let link of panel.links" mat-list-item [routerLink]="link.path" routerLinkActive="active-link">
        <mat-icon class="link-icon">{{ link.icon }}</mat-icon>
        <span class="link-text">{{ link.label }}</span>
      </a>
    </mat-nav-list>
  </mat-expansion-panel>
</mat-nav-list>

<hr class="divider" />
<div class="user-info">
  <p>Logado como:</p>
  <strong>{{ username }}</strong>
</div>